import { createContext, use } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import type { SessionHook } from '@web/hooks'
import { useSession } from '@web/hooks'
import { ROUTES, isSafeRedirectPath } from '@web/router'

const RouteSession = createContext<SessionHook | null>(null)

export function SessionLayout() {
	return (
		<RouteSession value={useSession()}>
			<Outlet />
		</RouteSession>
	)
}

export function useRouteSession(): SessionHook {
	const session = use(RouteSession)
	if (!session) throw new Error('useRouteSession was called outside SessionLayout')
	return session
}

export function AppLayout() {
	const { state } = useRouteSession()
	const { pathname, search } = useLocation()

	if (state.status === 'anonymous') {
		const target = isSafeRedirectPath(pathname) ? `${pathname}${search}` : ROUTES.getStarted
		return <Navigate to={`${ROUTES.signIn}?redirect=${encodeURIComponent(target)}`} replace />
	}

	return <Outlet />
}
